var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border":"3px solid purple","padding":"10px","background":"pink"}},[_c('h3',[_vm._v("✅ SimpleTestComponent 渲染成功！")]),_c('p',[_vm._v("如果你能看到这段文字，说明 .vue 文件组件可以正常工作")])])
}]

export { render, staticRenderFns }